module.exports = __webpack_public_path__ + "img/mapa.581c70ae.jpg";